import { CheckOutlined, CloseOutlined, FileProtectOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Input, InputRef, Space } from "antd"
import { useContext, useEffect, useRef, useState } from "react"
import styles from './styles.module.less'
import classNames from "classnames"
import { useRequest } from "ahooks"
import { SimulationModal, createSimSeq, getSimSeqs } from "@/services/project/simulation.service"
import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { ManualInputs } from "./ManualInputs/ManualInputs"
import { SimSeqCompinent } from "./SimSeqCompinent/SimSeqComponent"
import { SeqActionRow } from "./SeqActionRow/SeqActionRow"
import Dialog from "@/libs/dialog"
import { UnitStates } from "../../../UnitSelect/UnitSelect"
import { RunState, getStatus } from "@/store/flowsheet/flowsheet.slice"
import { useSelector } from "react-redux"

interface SimulationWorkbookProps {
  simulation?: SimulationModal
}

export const SimulationWorkbook = (props: SimulationWorkbookProps) => {
  const {simulation} = props
  const [visible, setVisible] = useState(false)
  const {data: sims =[], run: loadSimSeqs} = useRequest(() => getSimSeqs({sId: simulation?.id}), {manual: true})
  const {getAllUnits} = useContext(FlowsheetContext)
  const [units, setUnits] = useState<UnitStates>({nodes: [], lines: [], operations: []})
  const [newSeq, setNewSeq] = useState(null)
  const [selectedSeqId, setSelectedSeqId] = useState<number | null>(null)
  const inputRef = useRef<InputRef>(null)
  const status = useSelector(getStatus);

  useEffect(() => {
    if (simulation && visible) {
      loadSimSeqs()
    }
  }, [simulation, visible])

  useEffect(() => {
    if (visible) {
      getAllUnits().then((units) => {
        setUnits(units)
      })
    }
  }, [visible])

  const reset = () => {
    setVisible(false)
    setNewSeq(null)
    setSelectedSeqId(null)
  }

  const onCreate = async () => {
    const value = inputRef.current?.input?.value
    if (!(value && simulation)) {
      return
    }
    await createSimSeq({sequence: {
      name: value,
      intialGuess: [],
      target: []
    }}, {sId: simulation.id})
    setNewSeq(null)
    await loadSimSeqs()
  }

  const selectedSeq = sims.find(item => item.index === selectedSeqId)

  return <div>
    <Button disabled={status === RunState.Stop} icon={<FileProtectOutlined />} onClick={() => setVisible(true)}>Simulation Workbook</Button>

    {visible && <Dialog width={1000} title="Simulation Workbook" visible={true} footer={null} onClose={() => reset()} className={styles.workbookModal}>
      {/* <h3 className={styles.header}>Simulation Workbook</h3> */}
      <div className={styles.body}>
        <div className={styles.leftPanel}>
          <div className="mt-1" style={{padding: '5px'}}>
            <div className={classNames('flex-space-btw', styles.actionItem, !selectedSeq && styles.active)} onClick={() => setSelectedSeqId(null)}>
              <div>Manual Inputs</div>
            </div>
            <div className="mt-1">Solving Sequences</div>
            <div>
              {simulation && sims.map(item => {
                return <SeqActionRow
                  key={item.index}
                  refresh={() => loadSimSeqs()}
                  sim={simulation}
                  seq={item}
                  active={item.index === selectedSeq?.index}
                  onSelect={(simSeq) => setSelectedSeqId(simSeq.index)}
                />
              })}
            </div>
            {newSeq && <Space style={{padding: '5px'}}>
              <Input style={{flex: 1}} ref={inputRef} />
              <Space>
                <Button icon={<CheckOutlined />} style={{color: 'green'}} onClick={onCreate} />
                <Button icon={<CloseOutlined />} style={{color: 'red'}} onClick={() => setNewSeq(null)}/>
              </Space>
            </Space>}
          </div>
          <div className={styles.seqAdd}>
            <Button type="text"
            icon={<PlusOutlined />}
            onClick={() => {
              setNewSeq({} as any)
            }}
            style={{width: '100%'}}
            >Add</Button>
          </div>
        </div>
        <div className={styles.rightPanel}>
          {!selectedSeq && simulation && <ManualInputs units={units} simulation={simulation} />}
          {selectedSeq && simulation && <SimSeqCompinent units={units} simulation={simulation} seq={selectedSeq} reload={() => loadSimSeqs()} key={selectedSeq.index} />}
        </div>
      </div>
    </Dialog>}
    {/* {visible && <Modal
      open={true}
      width={1000}
      maskClosable={false}
      onCancel={() => reset()}
      footer={null}
    >
      <h3 className={styles.header}>Simulation Workbook</h3>
      <div className={styles.body}>
        <div className={styles.leftPanel}>
          <div className="mt-1" style={{padding: '5px'}}>
            <div className={classNames('flex-space-btw', styles.actionItem, !selectedSeq && styles.active)} onClick={() => setSelectedSeqId(null)}>
              <div>Manual Inputs</div>
            </div>
            <div className="mt-1">Solving Sequences</div>
            <div>
              {simulation && sims.map(item => {
                return <SeqActionRow
                  key={item.index}
                  refresh={() => loadSimSeqs()}
                  sim={simulation}
                  seq={item}
                  active={item.index === selectedSeq?.index}
                  onSelect={(simSeq) => setSelectedSeqId(simSeq.index)}
                />
              })}
            </div>
            {newSeq && <Space style={{padding: '5px'}}>
              <Input style={{flex: 1}} ref={inputRef} />
              <Space>
                <Button icon={<CheckOutlined />} style={{color: 'green'}} onClick={onCreate} />
                <Button icon={<CloseOutlined />} style={{color: 'red'}} onClick={() => setNewSeq(null)}/>
              </Space>
            </Space>}
          </div>
          <div className={styles.seqAdd}>
            <Button type="text"
            icon={<PlusOutlined />}
            onClick={() => {
              setNewSeq({} as any)
            }}
            style={{width: '100%'}}
            >Add</Button>
          </div>
        </div>
        <div className={styles.rightPanel}>
          {!selectedSeq && simulation && <ManualInputs units={units} simulation={simulation} />}
          {selectedSeq && simulation && <SimSeqCompinent units={units} simulation={simulation} seq={selectedSeq} reload={() => loadSimSeqs()} />}
        </div>
      </div>
    </Modal>} */}
  </div>
}